import { AppHelper } from "../appHelper"
import { TextBox } from "../core/components/textBox";
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { Helper } from "../core/util/helper";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { ComponentHelper } from "../core/util/componentHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType } from "../../siteManagement/sheet";
import { Dialog } from "../core/components/dialog";
import { FieldInstance } from "../core/components/field";
import { GeocodeStatus } from "../geomap/components/geocode/geocodeStatus";
import Skills from "../core/components/skills";
import { SkillChangeLogGrid } from "../generalSettings/skills/skillChangeLogGrid";
import { SkillHelper } from "../generalSettings/skills/skillsHelper";
import RessVisaInGrid, { RessVisa } from "./ressVisaInGrid";
import WindowsClient from "./windowsClient";
import MobileClient from "./mobileClient";
import RessSchulInGrid, { RessSchul } from "./ressSchulInGrid";
import RessImpfInGrid, { RessImpf } from "./ressImpfInGrid";
import RessWerkInGrid, { RessWerk } from "./ressWerkInGrid";
import RessGenehmInGrid, { RessGenehm } from "./ressGenehmInGrid";
import RessSozialInGrid, { RessSozial } from "./ressSozialInGrid";
import RessVersetzInGrid, { RessVersetz } from "./ressVersetzInGrid";
import RessPassApp from "./ressPass";
import { ColorPicker } from "../core/components/colorPicker";
import { FAIcon } from "../core/components/faIcon";
import { openStateDialog } from "../address/stateDialog";
import { TreeNodeVm } from "../generalSettings/skills/skillsInterfaces";
import { RessPass } from "./ressPassInGrid";
import { RessPala } from "./ressPalaInGrid";
import { PageTitleProps } from "../core/components/pageTitle";
import React from "react";
export default class ResourceApp extends React.Component<ResourceAppProps, ResourceState> {
    private ressTypeDS = [];


    common = new AppHelper();
    currentUrl: string = null;
    deleteEnabled = false;
    isDeleted = false;
    resourceSkills = true;
    ResourceSkillsRight = {};
    vacationListGridOptions = {};
    ressurlaubGridOptions = {};
    translations = {};
    ressVisaInGridOptions = {};
    ressSchulInGridOptions = {};
    ressImpfInGridOptions = {};
    ressPassInGridOptions = {};
    ressPalaInGridOptions = {};
    ressWerkInGridOptions = {};
    ressGenehmInGridOptions = {};
    ressSozialInGridOptions = {};
    ressVersetzInGridOptions = {};
    //schaltet den Browsertab-Titel an; wird von common aufgerufen
    setTabTitle = true;
    textBoxValue: string = "";
    factory = ComponentHelper.createFactory();
    geocode: GeocodeStatus = null;
    ressVisaInGridRef: RessVisaInGrid;
    ressSchulInGridRef: RessSchulInGrid;
    ressImpfInGridRef: RessImpfInGrid;
    ressPassAppRef: RessPassApp;
    ressWerkInGridRef: RessWerkInGrid;
    ressGenehmInGridRef: RessGenehmInGrid;
    ressSozialInGridRef: RessSozialInGrid;
    ressVersetzInGridRef: RessVersetzInGrid;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.common.addInGridValidation([
            { gridOptions: this.ressVisaInGridOptions, model: "entity.RessVisas", gridName: Helper.getTranslation("WebSMS.Resource.Visa") },
            { gridOptions: this.ressSchulInGridOptions, model: "entity.RessSchuls", gridName: Helper.getTranslation("WebSMS.Resource.Schulungen") },
            { gridOptions: this.ressImpfInGridOptions, model: "entity.RessImpfs", gridName: Helper.getTranslation("WebSMS.Resource.Impfungen") },
            { gridOptions: this.ressPassInGridOptions, model: "entity.RessPass", gridName: Helper.getTranslation("WebSMS.Resource.Reisepass") },
            { gridOptions: this.ressPalaInGridOptions, model: "entity.RessPalas", gridName: Helper.getTranslation("WebSMS.Resource.Reisepass") },
            { gridOptions: this.ressWerkInGridOptions, model: "entity.RessWerks", gridName: Helper.getTranslation("WebSMS.Resource.Werkzeuge") },
            { gridOptions: this.ressGenehmInGridOptions, model: "entity.RessGenehms", gridName: Helper.getTranslation("WebSMS.Resource.Arbeitsgenehmigung") },
            { gridOptions: this.ressSozialInGridOptions, model: "entity.RessSozials", gridName: Helper.getTranslation("WebSMS.Resource.Sozialversicherung") },
            { gridOptions: this.ressVersetzInGridOptions, model: "entity.RessVersetzs", gridName: Helper.getTranslation("WebSMS.Resource.Versetzung") }
        ]);
        this.props.context.vacationListGridOptions = this.vacationListGridOptions;
        this.props.context.ressurlaubGridOptions = this.ressurlaubGridOptions;
        this.props.context.translations = this.translations;
        this.props.context.ressVisaInGridOptions = this.ressVisaInGridOptions;
        this.props.context.ressSchulInGridOptions = this.ressSchulInGridOptions;
        this.props.context.ressImpfInGridOptions = this.ressImpfInGridOptions;
        this.props.context.ressPassInGridOptions = this.ressPassInGridOptions;
        this.props.context.ressPalaInGridOptions = this.ressPalaInGridOptions;
        this.props.context.ressWerkInGridOptions = this.ressWerkInGridOptions;
        this.props.context.ressGenehmInGridOptions = this.ressGenehmInGridOptions;
        this.props.context.ressSozialInGridOptions = this.ressSozialInGridOptions;
        this.props.context.ressVersetzInGridOptions = this.ressVersetzInGridOptions;
        this.state = { showRebookDialoge: false };
        this.refreshDeleteEnabled();
        this.handleFieldChange({ model: "entity.Obergruppe" }, this.props.entity.Obergruppe, null, true);
    }


    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite
    }

    getComponent = () => {
        let textboxRessnr = ComponentHelper.createFactory().getDefaultTextBoxProps();
        textboxRessnr.field.model = "RessNr";
        var grid = <TextBox {...textboxRessnr} />;
        return grid;
    }


    remove = () => {
        DialogHelper.confirm(Config.translations.deleteMessage).then(isOK => {
            if (isOK) {
                HTTPService.post<JsonResultClass>('Resource/Delete?ressNr=' + encodeURIComponent(this.props.entity.Ressnr))
                    .then(result => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            if (this.common.isWindow) {
                                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                                this.common.sheetWrapper.hide();
                            } else {
                                this.deleteEnabled = false;
                                this.isDeleted = true;
                                this.props.entity.RecordRight.CanWrite = false;
                                this.setState({});
                                setTimeout(() => {
                                    window.location.href = Config.baseUrl + "DynamicSearch/Resource";
                                }, 1000);
                            }
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    handleFieldChange = async (field: { model }, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.Ogrnr":
                if (this.props.entity.IsNew) {
                    this.handleFieldChange({ model: "entity.Stammogrnr" }, value)
                }
                break;
            case "entity.Grnr":
                if (this.props.entity.IsNew) {
                    this.handleFieldChange({ model: "entity.Stammgrnr" }, value)
                }
                break;
            case "entity.Ressnr":
                value = value.trim();
                break;
            case "entity.Obergruppe":
                MetaDataHelper.setFieldValue(this.props.entity, "entity.percentageWork", value / this.props.context.standardWorkTime * 100);
                break;
            case "entity.percentageWork":
                MetaDataHelper.setFieldValue(this.props.entity, "entity.Obergruppe", value * this.props.context.standardWorkTime / 100);
                break;
            case "entity.Status":
                if (value === 1) {
                    const result = await HTTPService.get<JsonResultClass>("ResourceLookup/ResHasDelegations?ressNr=" + encodeURIComponent(this.props.entity.Ressnr))
                    if (result.Code === 1) {
                        NotificationHelper.showWarningMessage(result.Message, { timeOut: 5000 });
                    }
                }
                break;
            case "entity.Bis":
                const isOk = await this.checkExitDate(value);
                if (!isOk)
                    value = this.props.entity.Bis;
                break;
            case "entity.CountryId":
                this.handleFieldChange({ model: "entity.StateId" }, null, null);
                if (Helper.hasValue(dataItem) && !Helper.isNullOrEmpty(dataItem.FallbackExpense)) {
                    this.handleFieldChange({ model: "entity.Land" }, dataItem.FallbackExpense, null);
                }
                break;
            case "entity.StateId":
                if (dataItem) {
                    const { updateKalenderId, updateTimezone } = await openStateDialog({
                        state: dataItem,
                        updateKalenderId: dataItem.KalenderId != this.props.entity.Kalenderid,
                        updateTimezone: dataItem.Timezone != this.props.entity.TimeZone
                    })
                    if (updateKalenderId && Helper.hasValue(dataItem.KalenderId)) {
                        this.handleFieldChange({ model: "entity.Kalenderid" }, dataItem.KalenderId, null)
                    }
                    if (updateTimezone && !Helper.isNullOrEmpty(dataItem.Timezone)) {
                        this.handleFieldChange({ model: "entity.TimeZone" }, dataItem.Timezone, null)
                    }
                }
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    private checkExitDate = async (exitDate: Date | string) => {
        if (!Helper.hasValue(exitDate))
            return true;
        const result = await HTTPService.get<JsonResultClass<number>>(`ResourceLookup/GetAssignmentsAfterExitDate?ressNr=${this.props.entity.Ressnr}&exitDate=${exitDate}`);
        if (result.Data == 0)
            return true;
        return await DialogHelper.confirm(Helper.getTranslation("WebSMS.Resource.StillAssignments").replace("{count}", result.Data.toString()).replace("{date}", new Date(exitDate).toLocaleDateString()));

    }

    save = (closeAfterSave, afterSave: () => void = null) => {
        for (const loadedModule of this.common.getLoadedModules()) {
            loadedModule.Save();
        }

        this.prepareSave();

        if (this.common.validate()) {
            const doSave = async (canSave: boolean, message: string) => {
                if (canSave) {

                    if (this.props.entity.GeocodeEnabled && !this.props.entity.UseResLocation) {

                        //update lat long
                        const resGeodataChanged = await GeocodeStatus.updateGecodeResource(
                            this.props.entity.Ressnr,
                            this.props.entity.Strasse,
                            this.props.entity.Plz,
                            this.props.entity.Ort,
                            this.props.entity.Land,
                            this.props.entity.Breitegrad,
                            this.props.entity.Laengegrad);

                        //update fields and gui
                        if (resGeodataChanged.changed) {
                            this.handleFieldChange({ model: "entity.Breitegrad" }, resGeodataChanged.lat);
                            this.handleFieldChange({ model: "entity.Laengegrad" }, resGeodataChanged.long);
                            if (resGeodataChanged.long == 0 && resGeodataChanged.lat == 0)
                                this.handleFieldChange({ model: "entity.GeocodeText" }, "");
                        }

                        //update timezone
                        let currentTimeZone = this.props.entity.TimeZone != null ? this.props.entity.TimeZone : "";
                        let changedCoords = (resGeodataChanged.changed && resGeodataChanged.lat != 0 && resGeodataChanged.lat != 0);
                        if (changedCoords || currentTimeZone == "") {
                            const timeZone = await GeocodeStatus.updateTimeZone(
                                changedCoords ? resGeodataChanged.lat : this.props.entity.Breitegrad,
                                changedCoords ? resGeodataChanged.long : this.props.entity.Laengegrad);
                            if (Helper.hasValue(timeZone) && timeZone != currentTimeZone) {
                                this.handleFieldChange({ model: "entity.TimeZone" }, timeZone);
                                NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.Geodata.TimeZoneUpdated"));
                            }
                        }
                    }

                    const result = await HTTPService.post<JsonResultClass<EntityResource>>("Resource/Save", this.props.entity)
                    if (result.Code === 0) {
                        if (this.props.entity.IsNew /*&& !this.common.isWindow*/) {
                            //history.pushState(null, null, Config.baseUrl + "Resource/Edit?id=" + this.props.entity.Ressnr);
                            General.Functions.HistoryState.replaceState("Resource/Edit?id=" + encodeURIComponent(this.props.entity.Ressnr));
                        }
                        let indivData = result.Data.IndividualFields
                        Helper.updateEntity(this.props.entity, result.Data);
                        for (var key in indivData) {
                            this.props.entity.IndividualFields[key] = indivData[key];
                        }
                        this.props.entity.IsNew = false;
                        this.refreshDeleteEnabled();
                        $(window).trigger("saveSkills", this.props.entity);
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.common.handlePostSave(result.Code === 0, closeAfterSave);
                    if (afterSave)
                        afterSave();
                } else {
                    NotificationHelper.showErrorMessage(message);
                }
            }

            if (this.props.entity.IsNew) {
                HTTPService.get<JsonResultClass>("ResourceLookup/IsRessnrAllocated?ressNr=" + encodeURIComponent(this.props.entity.Ressnr))
                    .then(result => doSave(result.Code === 0, result.Message));
            } else {
                doSave(true, null);
            }
        }
    }

    private prepareSave = () => {
        if (Helper.hasValue(this.ressVisaInGridRef))
            this.props.entity.RessVisas = this.ressVisaInGridRef.getEntries();
        if (Helper.hasValue(this.ressSchulInGridRef))
            this.props.entity.RessSchuls = this.ressSchulInGridRef.getEntries();
        if (Helper.hasValue(this.ressImpfInGridRef))
            this.props.entity.RessImpfs = this.ressImpfInGridRef.getEntries();
        if (Helper.hasValue(this.ressPassAppRef)) {
            this.props.entity.RessPass = this.ressPassAppRef.ressPassInGridRef.getEntries();
            this.props.entity.RessPalas = this.ressPassAppRef.ressPalaInGridRef.getEntries();
        }
        if (Helper.hasValue(this.ressWerkInGridRef))
            this.props.entity.RessWerks = this.ressWerkInGridRef.getEntries();
        if (Helper.hasValue(this.ressGenehmInGridRef))
            this.props.entity.RessGenehms = this.ressGenehmInGridRef.getEntries();
        if (Helper.hasValue(this.ressSozialInGridRef))
            this.props.entity.RessSozials = this.ressSozialInGridRef.getEntries();
        if (Helper.hasValue(this.ressVersetzInGridRef))
            this.props.entity.RessVersetzs = this.ressVersetzInGridRef.getEntries();
    }

    onGeocodeChange = (long: number, lat: number) => {
        this.handleFieldChange({ model: "entity.Laengegrad" }, long);
        this.handleFieldChange({ model: "entity.Breitegrad" }, lat);
        if (lat == 0 && long == 0)
            this.handleFieldChange({ model: "entity.GeocodeText" }, "");
    }

    renderGeocodeStatus = () => {
        return (
            <GeocodeStatus
                ref={(r) => { this.geocode = r }}
                commandManager={this.common.commandManager}
                GeocodeEnabled={this.props.entity.GeocodeEnabled}
                Laengegrad={this.props.entity.Laengegrad}
                Breitegrad={this.props.entity.Breitegrad}
                GeocodeText={this.props.entity.GeocodeText}
                onGeocodeDataChange={this.onGeocodeChange}
                readOnly={!this.props.entity.RecordRight.CanWrite}
                manualLocation={this.props.entity.UseResLocation === true}
                GeocodeMatch={this.props.entity.GeocodeMatch}
                GeocodeDisplayName={this.props.entity.GeocodeDisplayName}
            />
        );
    }

    rebookRessnr = () => {
        this.setState({ showRebookDialoge: true });
    }

    componentDidMount() {

        this.props.context.setEntityDirtyState = (isDirty) => this.common.setEntityDirtyState(isDirty);
    }

    private rebook = () => {
        if (this.textBoxValue.length === 0) {
            let warningMessage = this.translations["Standard.Pflichtfeld"].replace("{0}", this.translations["Ressource.NewPersonalNr"]);
            NotificationHelper.showWarningMessage(warningMessage);
            return false;
        } else if (this.textBoxValue.length > 10) {
            let errorMessage = Helper.getTranslation("Architecture.EFieldWidth").replace("{Fieldname}", this.translations["Ressource.NewPersonalNr"]);
            errorMessage = errorMessage.replace("{Width}", "10");
            NotificationHelper.showErrorMessage(errorMessage);
        }
        else {
            this.setState({ showRebookDialoge: false }, () => {
                this.save(false, () => {
                    HTTPService.post("Resource/RebookRessnr?ressnr=" + encodeURIComponent(this.textBoxValue) + "&oldRessnr=" + encodeURIComponent(this.props.entity.Ressnr)).then(result => {
                        if (result.Data) {
                            General.Functions.HistoryState.replaceState("Resource/Edit?id=" + this.textBoxValue);
                            let copyEntity = JSON.parse(JSON.stringify(this.props.entity));
                            copyEntity.Ressnr = this.textBoxValue;
                            this.props.context.keyVal1 = this.textBoxValue;
                            Helper.updateEntity(this.props.entity, copyEntity);
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.textBoxValue = "";
                            this.closeDialoge();
                            this.common.handlePostSave(result.Code === 0, false);
                            Helper.setBusyIndicator(true).then(() => {
                                setTimeout(() => {
                                    window.location.reload();
                                    Helper.setBusyIndicator(false);
                                }, 100)

                            })
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }

                    })
                });
            })
        }
        return false;

    }
    closeDialoge = () => {
        this.setState({ showRebookDialoge: false });
    }
    createDialoge = () => {
        var actions = [{ label: Config.translations.cancel, action: this.closeDialoge }, { label: Config.translations.ok, action: this.rebook, cancel: true, primary: true }];
        let textBoxProps = this.factory.getDefaultTextBoxProps();
        textBoxProps.value = this.textBoxValue;
        textBoxProps.field.maxLength = 10;
        textBoxProps.field.required = true;
        textBoxProps.required = true;
        textBoxProps.field.name = "Neue Personalnummer";
        textBoxProps.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.textBoxValue = value.trim();
        }

        return (
            <Dialog title={this.translations["Ressource.RebookRessnr"]}
                actions={actions} width={"800px"}
                open={this.state.showRebookDialoge}
            >
                <FieldInstance required={true} label={this.translations["Ressource.NewPersonalNr"]}>
                    <TextBox {...textBoxProps} />
                </FieldInstance>
            </Dialog>);
    }

    private onTreeDataChanged = (treeData: TreeNodeVm[]) => {
        this.common.setEntityDirtyState(true);
    }

    createSkills = () => {
        let entity: any = this.props.entity;
        return <Skills entity={entity} runningContext="resource" onTreeDataChanged={this.onTreeDataChanged}
            title={Helper.getTranslation["Ressource.Fähigkeiten"]} editable={true} />;
    }

    createSkillsChangeLog = () => {
        var refPos = SkillHelper.getRefPos("resource");
        return <SkillChangeLogGrid RefNr={this.props.entity.Ressnr} RefPos={refPos} />;
    }

    renderRessVisaInGrid = (defaultFieldProps: any) => {
        return <RessVisaInGrid {...this.props} ref={(ref) => this.ressVisaInGridRef = ref} helpUrl={defaultFieldProps.helpUrl} />
    }

    renderRessSchulInGrid = (defaultFieldProps: any) => {
        return <RessSchulInGrid {...this.props} ref={(ref) => this.ressSchulInGridRef = ref} helpUrl={defaultFieldProps.helpUrl} />
    }

    renderRessImpfInGrid = (defaultFieldProps: any) => {
        return <RessImpfInGrid {...this.props} ref={(ref) => this.ressImpfInGridRef = ref} helpUrl={defaultFieldProps.helpUrl} />
    }

    renderRessPass = (defaultFieldProps: any) => {
        return <RessPassApp {...this.props} ref={(ref) => this.ressPassAppRef = ref} helpUrl={defaultFieldProps.helpUrl}/>
    }

    renderRessWerkInGrid = (defaultFieldProps: any) => {
        return <RessWerkInGrid {...this.props} ref={(ref) => this.ressWerkInGridRef = ref} helpUrl={defaultFieldProps.helpUrl}/>
    }

    renderRessGenehmInGrid = (defaultFieldProps: any) => {
        return <RessGenehmInGrid {...this.props} ref={(ref) => this.ressGenehmInGridRef = ref} helpUrl={defaultFieldProps.helpUrl} />
    }

    renderRessSozialInGrid = (defaultFieldProps: any) => {
        return <RessSozialInGrid {...this.props} ref={(ref) => this.ressSozialInGridRef = ref} helpUrl={defaultFieldProps.helpUrl}/>
    }

    renderRessVersetzInGrid = (defaultFieldProps: any) => {
        return <RessVersetzInGrid {...this.props} ref={(ref) => this.ressVersetzInGridRef = ref} helpUrl={defaultFieldProps.helpUrl}/>
    }

    renderWindowsClient = () => {
        return <WindowsClient {...this.props} handleFieldChange={this.handleFieldChange} />
    }

    renderMobileClient = () => {
        return <MobileClient {...this.props} handleFieldChange={this.handleFieldChange} />
    }

    renderColorPicker = () => {
        const props = ComponentHelper
            .createFactory()
            .getDefaultColorPickerProps();
        props.value = this.props.entity.Farbe;
        props.onChange = (_, value) => {
            this.handleFieldChange({ model: "entity.Farbe" }, value);
        }
        let color = null;

        if (Helper.isNullOrEmpty(this.props.entity.Farbe)) {
            const item = this.ressTypeDS.find(f => f.Id == this.props.entity.Resstyp);
            if (item)
                color = item.FeldMemo
        }

        const texts = (" " + Helper.getTranslation("Field.Ressource.ressTypFallbackColor") + " ").split('{color}');


        return (
            <div style={{ display: "flex" }} >
                <ColorPicker {...props} />
                <div onClick={() => { this.handleFieldChange({ model: "entity.Farbe" }, null) }} style={{ borderRadius: "var(--border-radius)", borderWidth: "1px", borderStyle: "solid", borderColor: "#e4e7eb", height: "40px", width: "40px", display: !Helper.isNullOrEmpty(this.props.entity.Farbe) ? "flex" : "none", justifyContent: "center", alignItems: "center", marginLeft: "15px", cursor: "pointer" }}>
                    <FAIcon name={"trash-alt"} attributes={["lg"]} />
                </div>
                <div style={{ display: Helper.isNullOrEmpty(color) ? "none" : "flex", flexWrap: "wrap", marginLeft: "15px", alignItems: "center" }} >
                    <label style={{ fontSize: "15px" }}>{texts[0].trim()}</label>
                    <div style={{ backgroundColor: color, height: "14px", width: "14px", borderRadius: "50%", margin: "0 5px" }}></div>
                    <label style={{ fontSize: "15px" }}>{texts[1].trim()}</label>
                </div>

            </div>
        );
    }

    handleDataLoaded = (field, dataSource) => {
        switch (field.model) {
            case "entity.Resstyp":
                this.ressTypeDS = dataSource;
                this.setState({})
                break;
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleDataLoaded: this.handleDataLoaded });
        const titleProps: PageTitleProps = {
            title: this.props.title,
            value: this.props.entity.Ressnr,
        };
        const dialog = (this.state.showRebookDialoge) ? this.createDialoge() : null;
        return <>
            {dialog}
            <CommonApp {...props} titleProps={titleProps} /></>;
    }
};
interface ResourceState {
    showRebookDialoge: boolean;
}

export interface ResourceAppProps extends AppBaseProps {
    entity: EntityResource;
    context: ResourceAppPropsContext;
}


export interface EntityResource extends Entity {
    Stammgrnr: number;
    Stammogrnr: number;
    Kalenderid: number;
    Resstyp: any;
    Farbe: string;
    Bis: any;
    Ressnr: string;
    Obergruppe: string;
    Pwuser_Name: string;
    Pwuser_SignaturePadType: number | string;
    Vorname: string;
    Name: string;
    Email1: string;
    GeocodeEnabled: boolean;
    Laengegrad: number;
    Breitegrad: number;
    GeocodeText: string;
    Strasse: string;
    Plz: string;
    Ort: string;
    Land: string;
    UseResLocation: boolean;
    Useswindowsclient?: boolean;
    Usesapp?: boolean;
    RessVisasLoaded?: boolean;
    RessVisas: RessVisa[];
    RessSchulsLoaded?: boolean;
    RessSchuls: RessSchul[];
    RessImpfsLoaded?: boolean;
    RessImpfs: RessImpf[];
    RessPassLoaded?: boolean;
    RessPass: RessPass[];
    RessPalasLoaded?: boolean;
    RessPalas: RessPala[];
    RessWerksLoaded?: boolean;
    RessWerks?: RessWerk[];
    RessGenehmsLoaded?: boolean;
    RessGenehms?: RessGenehm[];
    RessSozialsLoaded?: boolean;
    RessSozials?: RessSozial[];
    RessVersetzsLoaded?: boolean;
    RessVersetzs?: RessVersetz[];
    TimeZone: string;
    GeocodeMatch: string;
    GeocodeDisplayName: string;
}

export interface ResourceAppPropsContext extends Context {
    standardWorkTime: number;
    vacationListGridOptions: {};
    ressurlaubGridOptions: {};
    materialGrid?: {};
    translations: {};
    ressVisaInGridOptions?: {};
    ressSchulInGridOptions?: {};
    ressImpfInGridOptions?: {};
    ressPassInGridOptions?: {};
    ressPalaInGridOptions?: {};
    ressWerkInGridOptions?: {};
    ressGenehmInGridOptions?: {};
    ressSozialInGridOptions?: {};
    ressVersetzInGridOptions?: {};
    setEntityDirtyState?: (isDirty: boolean) => void;
}